module.exports = __webpack_public_path__ + "root-c2082cbd/XING-Sans-Bold-3ba114329689bcfb7ffae73fb316f924.woff";